import React from 'react';
import PropTypes from 'prop-types';

/** Core */
import Icon from '../Icon';

/** Estilos */
import { StyledAlerts } from './style';

/** SVGs */
import { Warning } from '../../../../assets/images';

const Alerts = ({ className, children, type, visible }) => (
  <StyledAlerts className={className} type={type} visible={visible}>
    <span>
      <Icon svg={Warning} size="sm" color={type} className="mr-5 alert-icon" />
      {children}
    </span>
  </StyledAlerts>
);

Alerts.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  type: PropTypes.oneOf(['info', 'success', 'warning', 'error', 'light'])
};

Alerts.defaultProps = {
  type: 'info'
};

export default Alerts;
